import gql from 'graphql-tag';

import { MyExamScoreFragment } from '../query/fragments/ExamFragment';

export const mutateScores = gql`
  mutation setMyScores($myScores: [MyScoreRecord]!) {
    setMyScores(myScores: $myScores) {
      id
      myScores {
        ...MyExamScoreFragment
      }
    }
  }
  ${MyExamScoreFragment}
`;
